/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Illegal_TitleInputs */



/**
* | output |
* | --- |
* | "Illegal character detected (non 608)" |
*
* @param {Event_Warning_Illegal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_illegal_title = /** @type {((inputs?: Event_Warning_Illegal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Illegal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractère illégal détecté (non 608)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Zeichen erkannt (nicht 608)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carattere illegale rilevato (non 608)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружен недопустимый символ (не 608).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carácter ilegal detectado (distinto del 608)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测到非法字符（非 608）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不正な文字が検出されました（608以外）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवैध वर्ण का पता चला (गैर 608)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caractere ilegal detectado (diferente de 608)")
	return /** @type {LocalizedString} */ ("Illegal character detected (non 608)")
});